/**
 * Mantém o andamento do manual em dia.
 *
 * O motor não publica o progresso do manual por socket: a verdade é
 * `GET /api/v1/research/jobs/active`. Então a tela consulta
 *  - uma vez quando um turno TERMINA (é aí que o job do manual nasce: "Recebi o
 *    manual, leio em segundo plano"), e
 *  - a cada `MANUAL_POLL_MS` enquanto houver um manual em leitura (e só então:
 *    sem manual em voo não há consulta periódica).
 */
import { useEffect, useRef } from 'react'
import { useChatStore } from '../../stores/chatStore'
import { isManualRunning, useManualIngestJobsStore } from '../../stores/manualIngestJobsStore'
import { useResearchJobsStore } from '../../stores/researchJobsStore'

export const MANUAL_POLL_MS = 5000

export function useManualIngestPolling(): void {
  const anyRunning = useManualIngestJobsStore((s) =>
    Object.values(s.jobs).some((job) => isManualRunning(job.stage)),
  )
  const isTyping = useChatStore((s) => s.isTyping)

  useEffect(() => {
    if (!anyRunning) return
    const timer = setInterval(() => void useResearchJobsStore.getState().hydrate(), MANUAL_POLL_MS)
    return () => clearInterval(timer)
  }, [anyRunning])

  const wasTyping = useRef(isTyping)
  useEffect(() => {
    // Só a borda de descida (turno terminou). A montagem inicial é coberta pelo
    // hydrate do carregamento, no ResearchJobsNotifier.
    if (wasTyping.current && !isTyping) void useResearchJobsStore.getState().hydrate()
    wasTyping.current = isTyping
  }, [isTyping])
}
